import React from 'react'
import { 
  FaqAccordion, 
  FaqContainer, 
  FaqFooter, 
  FaqHeading, 
  FaqImage, 
  FaqInfo, 
  FaqInfoChat, 
  FaqInfoLinks, 
  FaqInfoText, 
  FaqInfoTitle, 
  FaqQuestions, 
} from 'raffle-house-uikit';
import man4 from '../../extensions/images/man-4.jpg';
import man5 from '../../extensions/images/man-5.jpg';
import man2 from '../../extensions/images/man-2.jpg';
import man3 from '../../extensions/images/man-3.jpg';
import { faqs } from '../../lib/static-data'

import './styles.scss';

export default function Faq({content}) {
  return (
    <FaqContainer>
      <FaqQuestions>
        <FaqHeading>FAQs</FaqHeading>
        <FaqAccordion items={faqs} />
      </FaqQuestions>
      <FaqFooter>
        <FaqImage src={content.faq && content.faq.imageUrl ? content.faq.imageUrl : null} />
        <FaqInfo>
          <FaqInfoTitle>Got a question?</FaqInfoTitle>
          <FaqInfoText>We're here for you just about 24/7</FaqInfoText>
          <FaqInfoChat title='Chat to Loreen, Kathie, Harriet and Esther' images={[man5, man2, man3, man4]} />
          <FaqInfoLinks />
        </FaqInfo>
      </FaqFooter>
    </FaqContainer>
  )
}
